import { useState } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Showroom from "@/components/site/Showroom";
import EditorialMarquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import AcronymReveal from "@/components/site/AcronymReveal";
import Capsule from "@/components/site/Capsule";
import Register from "@/components/site/Register";
import Footer from "@/components/site/Footer";
import Loader from "@/components/site/Loader";

export default function Home() {
  const [loaded, setLoaded] = useState(false);

  return (
    <main data-testid="home-page" className="bg-black text-white">
      <Loader onDone={() => setLoaded(true)} />
      <Nav />
      <Hero startDelay={loaded ? 0.05 : 2.0} />
      <Showroom />
      <EditorialMarquee />
      <AcronymReveal />
      <Capsule />
      <Manifesto />
      <Register />
      <Footer />
    </main>
  );
}
